// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyTwoToneSvg from "@ant-design/icons-svg/es/asn/PropertySafetyTwoTone";
import AntdIcon from '../components/AntdIcon';

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyTwoToneSvg
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
export default React.forwardRef(PropertySafetyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PropertySafetyTwoTone.js
// module id = 1635
// module chunks = 0